import { useState } from "react";
import { useIsDarkMode } from "@common/ui/themes/use-is-dark-mode";
import clsx from "clsx";

export default function EnterPassword() {

	const isDarkMode = useIsDarkMode();
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");

	const submit = async (e: any) => {
		e.preventDefault();

		try {

			const res = await fetch("/verify-password", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-TOKEN": (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || ""
				},
				body: JSON.stringify({ password })
			});
			if (res.ok) {
				window.location.href = "/";
			} else {
				setError("Incorrect password");
			}

		} catch {
			setError("Server error. Try again.");
		}

	};

	return (
		<div className={clsx(
			"min-h-screen flex items-center justify-center transition-colors duration-300",
			isDarkMode ? "bg-[#0f172a]" : "bg-gray-100"
		)}>

			<div className={clsx(
				"w-[420px] p-8 rounded-xl shadow-xl transition-all duration-300",
				isDarkMode ? "bg-[#1e293b] text-white shadow-2xl shadow-black/20" : "bg-white text-gray-900"
			)}>

				<h1 className="text-2xl font-bold text-center mb-2">
					Website Protected
				</h1>

				<p className={clsx(
					"text-center mb-6",
					isDarkMode ? "text-gray-400" : "text-gray-500"
				)}>
					Enter password to access this site
				</p>

				<form onSubmit={submit} className="space-y-4">

					<input
						type="password"
						placeholder="Enter password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						className={clsx(
							"w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200",
							isDarkMode 
								? "bg-[#0f172a] border-gray-700 text-white placeholder:text-gray-500" 
								: "bg-white border-gray-300 text-gray-900 placeholder:text-gray-400"
						)}
					/>

					{error && (
						<p className="text-red-500 text-sm text-center">
							{error}
						</p>
					)}

					<button
						type="submit"
						style={{
							width: '100%',
							backgroundColor: '#0ea5e9',
							color: 'white',
							padding: '12px',
							borderRadius: '8px',
							fontWeight: '600',
							border: 'none',
							cursor: 'pointer',
							transition: 'all 0.2s'
						}}
						onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0284c7')}
						onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#0ea5e9')}
					>
						Enter Website
					</button>


				</form>

			</div>

		</div>
	);
}